import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api.js";
import type { Test, TestQuestion, TestChoice, TestResultType } from "@bongeunsa/db";

export type TestQuestionWithChoices = TestQuestion & { choices: TestChoice[] };

export type ActiveTestResponse = {
  test: Test | null;
  questions: TestQuestionWithChoices[];
  resultTypes: TestResultType[];
};

export function useActiveTest(slug?: string) {
  return useQuery({
    queryKey: ["test", slug ?? "active"],
    queryFn: () =>
      slug
        ? api.get<ActiveTestResponse>(`/api/tests/slug/${slug}`)
        : api.get<ActiveTestResponse>("/api/tests/active"),
    staleTime: 1000 * 60 * 5,
  });
}
